import newhttp from '~/http/new';

export default ({
  state: {
    messages: [],
    page: 1,
    pages: 0,
    perPage: 50,
  },

  mutations: {
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },
    SET_MESSAGES(state, data) { state.messages = data; },
  },

  getters: {
    requestData(state) {
      const {
        page,
        perPage,
      } = state;
      return {
        offset: (page - 1) * perPage,
        limit: perPage,
      };
    },

    hasMoreMessages(state) {
      return state.messages.length === state.page * state.perPage;
    },
  },

  actions: {
    setPage({ commit }, value) { commit('SET_PAGE', value); },
    setPages({ commit }, value) { commit('SET_PAGES', value); },

    async loadData({ commit, getters, rootGetters }, id) {
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const response = await newhttp.get(`v1/communication/groupchat/${id}/messages`, {
        params: {
          ...getters.requestData,
          id,
        },
      });
      const { items, total } = response.data;
      commit('SET_MESSAGES', items);
      if (total) {
        const pages = Math.ceil(total / itemsPerPage);
        commit('SET_PAGES', pages);
      }
    },

    async sendMessage(__store, data) {
      await newhttp.post(`v1/communication/groupchat/${data.id}/messages`, data);
    },
  },

  namespaced: true,
});
